import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const Statistics = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const stats = [
    {
      number: "2016",
      label: "Serving Washington Since",
      suffix: ""
    },
    {
      number: "39",
      label: "Counties Served",
      suffix: ""
    },
    {
      number: "100%",
      label: "Committed to Safety",
      suffix: ""
    },
    {
      number: "5am-8pm",
      label: "Mon-Sat Dispatch",
      suffix: ""
    }
  ];

  return (
    <section className="statistics" id="statistics">
      <div className="container">
        <motion.div
          ref={ref}
          className="stats-grid"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          {stats.map((stat, index) => (
            <motion.div
              className={`stat-card ${index === 3 ? 'stat-card-hours' : ''}`}
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="stat-number">
                {stat.number}
                {stat.suffix && <span className="stat-suffix">{stat.suffix}</span>}
              </div>
              <div className="stat-label">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Statistics;

